import "./App.css"

import { BrowserRouter, Routes } from 'react-router-dom';
import { useEffect, useState } from "react";

import { getRoutesByAuth } from "./routes";
import store from "./stores/authStore";
import { logout } from "./reducers/auth.reducer";

const App = () => {
  const [isAuthenticate, setAuthenticate] = useState(
    () => Boolean(store.getState().auth.tokenValue)
  );

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setAuthenticate(Boolean(store.getState().auth.tokenValue));
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    let expirationTimer;

    const scheduleExpiration = () => {
      window.clearTimeout(expirationTimer);
      const { tokenValue, tokenExpirationTime } = store.getState().auth;
      if (!tokenValue) return;

      const remainingTime = Number(tokenExpirationTime) - Date.now();
      if (remainingTime <= 0) {
        store.dispatch(logout());
        return;
      }

      expirationTimer = window.setTimeout(
        scheduleExpiration,
        Math.min(remainingTime, 2_147_483_647)
      );
    };

    scheduleExpiration();
    const unsubscribe = store.subscribe(scheduleExpiration);

    return () => {
      unsubscribe();
      window.clearTimeout(expirationTimer);
    };
  }, []);
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Routes>{getRoutesByAuth(isAuthenticate, store.getState().auth.user)}</Routes>
    </BrowserRouter>
  );
};

export default App;
